export enum UserRoles {
	Individual = 1,
	Business = 2,
	Government = 3,
	Internal = 4,
}
